<template>
  <div>
    <div
      v-for="(addOnGroup, index) in addOns"
      :key="index"
      class="product__variation"
    >
      <label
        class="product__variation__label"
        :for="'addon-' + index"
      >{{ addOnGroup['label'] }}</label>
      <div class="product__variation__field select">
        <select
          :id="'addon-' + index"
          v-model="selectedAddOns[index]"
          @change="onChange()"
        >
          <option
            v-for="(addOn, i) in addOnGroup['products']"
            :key="i"
            :value="addOn"
          >
            {{ addOn.name }} <template v-if="!hidePrices">
              (<price
                :price-without-tax="addOn.prices_without_tax.price"
                :price-with-tax="addOn.prices_with_tax.price"
              />)
            </template>
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            addOns: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            hidePrices: Boolean,
            originalSelectedAddOns: {
                type: Array,
                default: function () {
                    return [];
                },
            },
        },
        data : function () {
            return {
                selectedAddOns : {},
                totalWithoutTax: 0,
                totalWithTax: 0,
                regularPriceTotalWithoutTax: 0,
                regularPriceTotalWithTax: 0,
            };
        },
        mounted: function () {
            let self = this;
            if (!_.isEmpty(this.originalSelectedAddOns )) {
                let selectedAddOns = {};

                let index = 0;
                this.addOns.forEach(addOnGroup => {
                    addOnGroup.products.forEach(product => {
                        self.originalSelectedAddOns.forEach(originalAddOn => {
                            if (originalAddOn.product_id == product.id &&
                                originalAddOn.variation_id == product.variation_id
                            ) {
                                selectedAddOns[index] = product;
                            }
                        });
                    });
                    index++;
                });

                this.selectedAddOns = selectedAddOns;
            }

            this.updateTotals();
            this.$emit('change', {
                addOns: _.clone(this.selectedAddOns),
                totals: {
                    totalRegularWithoutTax: this.regularPriceTotalWithoutTax,
                    totalRegularWithTax: this.regularPriceTotalWithTax,
                    totalWithoutTax: this.totalWithoutTax,
                    totalWithTax: this.totalWithtTax,
                },
            });
        },
        methods: {

            setDefaultValues() {
                let selectedAddOns = _.clone(this.selectedAddOns);

                if (this.addOns.length > 0) {
                    for (let i=0; i < this.addOns.length; i++) {
                        selectedAddOns[i] = this.addOns[i]['products'][0];
                    }
                }
                this.selectedAddOns = selectedAddOns;
                this.$emit('change', {
                    addOns: _.clone(this.selectedAddOns),
                    totals: {
                        totalRegularWithoutTax: this.regularPriceTotalWithoutTax,
                        totalRegularWithTax: this.regularPriceTotalWithTax,
                        totalWithoutTax: this.totalWithoutTax,
                        totalWithTax: this.totalWithTax,
                    },
                });
            },

            updateTotals() {
                let totalWithoutTax = 0;
                let totalWithTax = 0;
                let regularPriceTotalWithoutTax = 0;
                let regularPriceTotalWithTax = 0;
                _.values(this.selectedAddOns).forEach((addOn) => {
                    const pricesWithoutTax = addOn.prices_without_tax;
                    totalWithoutTax += pricesWithoutTax.price;
                    regularPriceTotalWithoutTax += pricesWithoutTax.regularPriceTotal;
                    const pricesWithTax = addOn.prices_with_tax;
                    totalWithTax += pricesWithTax.price;
                    regularPriceTotalWithTax += pricesWithTax.regularPriceTotal;
                });

                this.totalWithTax = totalWithTax;
                this.totalWithoutTax = totalWithoutTax;
                this.regularPriceTotalWithTax = regularPriceTotalWithTax;
                this.regularPriceTotalWithoutTax = regularPriceTotalWithoutTax;
            },

            onChange() {
                this.updateTotals();
                this.$emit('change', {
                    addOns: _.clone(this.selectedAddOns),
                    totals: {
                        totalRegularWithoutTax: this.regularPriceTotalWithoutTax,
                        totalRegularWithTax: this.regularPriceTotalWithTax,
                        totalWithoutTax: this.totalWithoutTax,
                        totalWithTax: this.totalWithTax,
                    },
                });
            },

        },
    }
</script>
